import moment from "moment";

export function timeDiff(name) {
  const startMoment = moment();

  console.log(
    name + " start time: " + startMoment.format("YYYY-MM-DD HH:mm:ss.SSS")
  );

  return function() {
    const endMoment = moment();
    console.log(
      name + " end time: " + endMoment.format("YYYY-MM-DD HH:mm:ss.SSS")
    );

    console.log(name + " total time: " + endMoment.diff(startMoment));
  };
}

export function startTime(seconds) {
  if (seconds > 0) {
    // 获取小时
    let hour = parseInt(seconds / 3600);
    if (hour < 10) {
      hour = `0${hour}`;
    }
    // 获取分钟
    const hourSurplus = seconds % 3600;
    let minute = parseInt(hourSurplus / 60);
    if (minute < 10) {
      minute = `0${minute}`;
    }
    // 获取秒钟
    let second = hourSurplus % 60;
    if (second < 10) {
      second = `0${second}`;
    }

    return `${hour}:${minute}:${second}`;
  }
}
